<template>
  <div id="app">
    <Header v-if="(!isENG)&&(headvalid)"></Header>
    <Headereng v-if="isENG&&headvalid"></Headereng>
    <router-view  :key="$route.fullPath"/>
    <Footer v-if="( !isENG)&&(footvalid)"></Footer>
    <Footereng v-if="isENG&&footvalid"></Footereng>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return{
      isENG:true,
      footvalid:true,
      headvalid:true,
    }
  },
  methods:{
    watchrouter(){
      var routename=this.$route.name
      if(routename.indexOf('ENG')!=-1){
        this.isENG=true;
      }else{
        this.isENG=false;
      }
      if(routename=='adminLogin'||routename=='fileUpload'){
        this.headvalid=false;
        this.footvalid=false;
      }else{
        this.headvalid=true;
        this.footvalid=true;

      }
    }
  },
  watch:{
    $route: 'watchrouter'
  }
}
</script>

<style>
.el-upload-list__item:hover .el-icon-close {
    display: none !important;
}

.el-upload-list__item-name{
    font-size: 16px !important;
  }

input[type=file]{
  display: none !important;
}textarea.el-textarea__inner{
  border: none !important;
}
.el-dialog__header {
    padding: 40px 50px 10px !important;
}.el-dialog__body {
    padding: 30px 70px 20px 50px !important;
}.el-dialog__footer {
    padding: 10px 70px 40px !important;
}

#manual .el-dialog__body{

  padding: 0px 20px 20px  !important;
}  #manual .el-carousel__arrow{
    background-color: rgba(31, 45, 61, 0.5) !important;
  }

.el-form-item__label{
        white-space: pre-line; /*换行显示*/
        height: 32px;/*设置lable高度，与input高度一样*/
        line-height: 16px!important;/*设置行高为label高度的一半（有n行就是label高度的1/n）*/
    }
.imgBox .el-dialog{
  width: 40% !important;
}
.imgBox .el-dialog__body{
  padding: 0px !important;
}
.imgBox .el-dialog__header{
  padding: 0px !important;
}
.imgBox .el-icon-close:before{
  font-weight: bold;
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue